<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartUsersEmail",
  data() {
    return {
      series:[],
      chartOptions: {
        chart: {
          id: 'users-email-providers',
          type: 'donut',
        },
        labels: [],
        dataLabels: {
          enabled: true
        },

        legend: {
          position: 'bottom'
        },
        noData: {
          text: 'Loading...'
        }
      },
      filtersDates: {
        selected: '1M',
        options: [
          {value:'T', text:'T.'},
          {value:'Y', text:'Y.'},
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
          {value:'ALL', text:'ALL'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersEmailProvidersStats(params)
          .then(response => {
            this.series = response.data.providers;
            this.chartOptions = {...this.chartOptions, ...{
                labels: response.data.labels
            }};
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersEmailProvidersStats failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardChartEmailProviders">
      <h5 class="card-title">Email Providers Distribution</h5>
      <b-form-radio-group
          v-model="filtersDates.selected"
          :options="filtersDates.options"
          button-variant="outline-secondary"
          size="sm"
          buttons
          @change="handleDateChange"
          class="mt-1 mb-2"
      ></b-form-radio-group>
    <apexchart
        ref="usersEmailProvidersChart"
        type="donut"
        height="350"
        dir="ltr"
        :series="series"
        :options="chartOptions"
    ></apexchart>
  </div>
</template>

<style>
#cardChartEmailProviders .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardChartEmailProviders .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>